<template>
  <div class="users-management">
    <SearchMessage
      :fileInfo="fileInfo"
      :showModal="showModal"
      @closeModal="showModal = false"
    />
    <template v-if="currentDepartment.rol_name == 'superuser'">
      <h1>
        <b
          >{{ currentDepartment.department_name.toUpperCase() }} Users
          Management</b
        >
      </h1>
      <hr />
    </template>

    <div class="spinner" v-if="!thereIsData">
      <Loading size="200" />
    </div>

    <div v-if="thereIsData">
      <template v-if="currentDepartment.rol_name != 'superuser'">
        <PageNotAllowed :busy="false" />
      </template>
      <template v-if="currentDepartment.rol_name == 'superuser'">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="Charlie Users" name="first">
            <div class="users-management__buttons">
              <!-- <div>
            <NewUser v-model="userId" />
          </div> -->
              <!-- <div class="users-management__buttons__title">
            <h4>
              <strong>Total Quotes Unassigned:</strong> {{ totalUnassigned }}
            </h4>
          </div> -->
              <div class="users-management__buttons__content">
                <b-button
                  v-b-modal.bv-search-message
                  class="users-management__buttons__content--option"
                  size="sm"
                  @click="getRouteFiles()"
                  >Search message <b-icon icon="search"></b-icon
                ></b-button>
                <b-button
                  v-if="currentDepartment.department_id == 1"
                  @click="showAssignor = !showAssignor"
                  class="users-management__buttons__content--option"
                  size="sm"
                  >Auto-assign
                  <b-icon v-if="!showAssignor" icon="caret-down"></b-icon
                  ><b-icon v-if="showAssignor" icon="caret-up"></b-icon>
                </b-button>
                <!-- code to delete if approved in the next PR -->
                <!-- <b-overlay
                  :show="gettingStatistics"
                  rounded
                  opacity="0.6"
                  spinner-small
                  class="d-inline-block"
                >
                  <b-button
                    @click="getStatistics"
                    :disabled="gettingStatistics"
                    class="users-management__buttons__content--option"
                    size="sm"
                    >Statistics
                    <b-icon v-if="!thereIsStatistics" icon="caret-down"></b-icon
                    ><b-icon v-if="thereIsStatistics" icon="caret-up"></b-icon>
                  </b-button>
                </b-overlay> -->
                <!-- <b-form-input
              v-model="numberOfQuotes"
              placeholder="Quotes"
              type="number"
              size="sm"
              class="users-management__buttons__content--input"
              autocomplete="off"
              min="0"
            ></b-form-input>
            <b-overlay
              :show="distributing"
              rounded
              opacity="0.6"
              spinner-small
              class="d-inline-block"
            >
              <b-button
                @click="distributeQuotes"
                :disabled="distributing"
                class="users-management__buttons__content--option"
                size="sm"
                >Distribute</b-button
              >
            </b-overlay>
            <b-overlay
              :show="clearing"
              rounded
              opacity="0.6"
              spinner-small
              class="d-inline-block"
            >
              <b-button
                @click="clearAll"
                :disabled="clearing"
                class="users-management__buttons__content--option"
                size="sm"
                >Clear all</b-button
              >
            </b-overlay> -->
              </div>

              <!-- New user table to change cards -->
              <!-- <div class="users-management__buttons__content">
            <b-button
              v-b-modal.bv-search-message
              class="users-management__buttons__content--option"
              size="sm"
              @click="getRouteFiles()"
              >Search message <b-icon icon="search"></b-icon
            ></b-button>
            <b-overlay
              :show="gettingStatistics"
              rounded
              opacity="0.6"
              spinner-small
              class="d-inline-block"
            >
              <b-button
                @click="getStatistics"
                :disabled="gettingStatistics"
                class="users-management__buttons__content--option"
                size="sm"
                >Statistics
                <b-icon v-if="!thereIsStatistics" icon="caret-down"></b-icon
                ><b-icon v-if="thereIsStatistics" icon="caret-up"></b-icon>
              </b-button>
            </b-overlay>
          </div> -->
            </div>

            <div v-if="showAssignor && currentDepartment.department_id == 1">
              <AssingmentForm></AssingmentForm>
            </div>
            <!-- code to delete if approved in the next PR -->
            <!-- Users Cards -->
            <!-- <div class="users-management__users-content">
          <template v-for="user in users">
            <template v-if="!user.is_busy && user.is_active">
              <User v-bind:key="user.id" v-model="userQuotes" :user="user" />
            </template>
          </template>
          <template v-for="user in users">
            <template v-if="user.is_busy && user.is_active">
              <User v-bind:key="user.id" v-model="userQuotes" :user="user" />
            </template>
          </template>
          <template v-for="user in users">
            <template v-if="!user.is_active">
              <User v-bind:key="user.id" v-model="userQuotes" :user="user" />
            </template>
          </template>
        </div> -->

            <!-- usertable to change cards -->
            <div class="users-management__users-content">
              <UsersTable
                v-if="activeName === 'first'"
                :activeName="activeName"
                v-model="userQuotes"
                :users="users"
                :totalUnassigned="totalUnassigned"
                @getUsers="getUsers"
              />
            </div>
          </el-tab-pane>
          <el-tab-pane label="Uploader Users" name="second">
            <div class="users-management__users-content">
              <UsersTable
                v-if="activeName === 'second'"
                :activeName="activeName"
                v-model="userQuotes"
                :users="users"
                :totalUnassigned="totalUnassigned"
                @getUsers="getUsers"
              />
            </div>
          </el-tab-pane>
          <el-tab-pane label="Statistics" name="third">
            <!-- code to delete if approved in the next PR -->
            <!-- <div class="users-management__buttons">
              <div class="users-management__buttons__content">
                <b-overlay
                  :show="gettingStatistics"
                  rounded
                  opacity="0.6"
                  spinner-small
                  class="d-inline-block"
                >
                  <b-button
                    @click="getStatistics"
                    :disabled="gettingStatistics"
                    class="users-management__buttons__content--option"
                    size="sm"
                    >Statistics
                    <b-icon v-if="!thereIsStatistics" icon="caret-down"></b-icon
                    ><b-icon v-if="thereIsStatistics" icon="caret-up"></b-icon>
                  </b-button>
                </b-overlay>
              </div>
            </div> -->

            <div v-if="thereIsStatistics" class="users-management__statistics">
              <Statistics :data="statistics" />
            </div>
          </el-tab-pane>
        </el-tabs>
      </template>
    </div>
  </div>
</template>

<script>
// import User from "./components/User";
// import NewUser from "./NewUser";
import Statistics from "./components/Statistics.vue";
import AssingmentForm from "./components/AssignmentForm.vue";
import PageNotAllowed from "@/components/PageNotAllowed";
import Loading from "@/components/Loading";
import SearchMessage from "./components/SearchMessage.vue";
import { mapGetters } from "vuex";
import UsersTable from "./components/UsersTable.vue";

export default {
  name: "UsersManagement",
  components: {
    // User,
    // NewUser,
    Statistics,
    AssingmentForm,
    PageNotAllowed,
    Loading,
    SearchMessage,
    UsersTable
  },
  data() {
    return {
      users: null,
      thereIsData: false,
      userId: null,
      userQuotes: [],
      distributing: false,
      clearing: false,
      numberOfQuotes: null,
      gettingStatistics: false,
      thereIsStatistics: false,
      statistics: null,
      departmentId: null,
      totalUnassigned: null,
      fileInfo: {},
      showModal: false,
      currentDepartment: null,
      showAssignor: true,
      activeName: "first"
    };
  },
  computed: {
    ...mapGetters("login", ["showInfoDepartment"]),
    ...mapGetters("usersManagement", ["showDataUsersSocketListener"])
  },
  watch: {
    async userId() {
      this.thereIsData = false;
      await this.getUsers();
      this.thereIsData = true;
    },
    async userQuotes() {
      await this.getUsers();
    },
    showInfoDepartment(value) {
      this.currentDepartment = value;
    },
    showDataUsersSocketListener(data) {
      const nameDto =
        this.currentDepartment?.department_name === "otr" ? "ftl" : "ltl";
      if (data[nameDto]?.quote_resume) {
        for (let i = 0; i < data[nameDto].quote_resume.length; i++) {
          this.users[i].id = data[nameDto].quote_resume[i].user_id;
          this.users[i].is_active = data[nameDto].quote_resume[i].is_active;
          this.users[i].is_busy = data[nameDto].quote_resume[i].is_busy;
          this.users[i].quote_resume.failed =
            data[nameDto].quote_resume[i].failed;
          this.users[i].quote_resume.process =
            data[nameDto].quote_resume[i].process;
          this.users[i].quote_resume.queue =
            data[nameDto].quote_resume[i].queue;
          this.users[i].quote_resume.sent = data[nameDto].quote_resume[i].sent;
          this.users[i].rol_id = data[nameDto].quote_resume[i].rol_id;
          this.users[i].username = data[nameDto].quote_resume[i].username;
        }
      }
      this.totalUnassigned = data[nameDto]?.total_quotes_unassigned;
    }
  },
  async created() {
    this.currentDepartment = this.showInfoDepartment;
    this.departmentId = this.currentDepartment.department_id;
    let info = {};
    info.department = this.departmentId;
    this.getEntryType(info);
    this.totalUnassigned = await this.$store.dispatch(
      "quotes/getTotalUnassigned",
      info
    );
    this.getUsers();
    this.dataUsersSocket();
    this.getAutoassignerInfo();
  },
  destroyed() {
    this.$store.commit("usersManagement/closeDataUsersSocketListener");
  },
  methods: {
    async getUsers() {
      let info = {
        activeName: this.activeName,
        departmentId: this.departmentId
      };
      info.rolId =
        this.activeName === "first" ? this.currentDepartment.rol_id : 1;
      await this.$store.dispatch("usersManagement/getUsers", info);
      this.users = this.$store.getters["usersManagement/showUsers"];
      this.thereIsData = true;
    },
    async dataUsersSocket() {
      if (
        this.currentDepartment.department_name === "otr" ||
        this.currentDepartment.department_name === "ltl"
      ) {
        await this.$store.dispatch("usersManagement/dataUsersSocket");
      }
    },
    async distributeQuotes() {
      this.distributing = true;
      let info = {};
      info.departmentId = this.$store.getters[
        "login/showUserLoggedIn"
      ][0].department.id;
      info.numberOfQuotes = this.numberOfQuotes;
      let response = await this.$store.dispatch(
        "usersManagement/allocate/distributeQuotes",
        info
      );
      this.numberOfQuotes = null;
      this.distributing = false;
      if (response.status == 200) {
        this.getUsers();
      }
    },
    async clearAll() {
      let departmentId = this.$store.getters["login/showUserLoggedIn"][0]
        .department.id;
      this.clearing = true;
      let response = await this.$store.dispatch(
        "usersManagement/allocate/clearQuotes",
        departmentId
      );
      this.numberOfQuotes = null;
      this.clearing = false;
      if (response.status == 200) {
        this.getUsers();
      }
    },
    async getStatistics() {
      this.thereIsData = false;
      let departmentId = this.$store.getters["login/showUserLoggedIn"][0]
        .department.id;
      this.gettingStatistics = true;
      if (!this.thereIsStatistics) {
        let response = await this.$store.dispatch(
          "usersManagement/allocate/getStatistics",
          departmentId
        );
        this.statistics = response.data;
        this.thereIsData = true;
      }
      this.thereIsStatistics = !this.thereIsStatistics;
      this.gettingStatistics = false;
      this.thereIsData = true;
    },
    getRouteFiles(data) {
      this.fileInfo = data;
      this.showModal = true;
    },
    getEntryType(info) {
      let actualQueue = localStorage.getItem("actual-queue");
      if (this.currentDepartment.department_id == 2) {
        if (actualQueue == "ftl") {
          info.entry_type = [
            "GRAPH-FTL",
            "GRAPH-HH",
            "GRAPH-SPECIALSERVICES",
            "GRAPH-TEMPCONTROL",
            "SS-Manual",
            "FTL-Manual",
            "HH-Manual",
            "TC-Manual",
            "GRAPH-OTR",
            "OTR-Manual"
          ];
        }
        if (actualQueue == "drayage") {
          info.entry_type = ["GRAPH-DRAYAGE"];
        }
      } else if (this.currentDepartment.department_id == 1) {
        info.entry_type = [
          "GRAPH",
          "Manual",
          "GRAPH-KNSUPPORT",
          "GRAPH-LATINPRO"
        ];
      }
    },
    async handleClick(tab) {
      if (tab.index === "2") {
        this.thereIsStatistics = false;
        await this.getStatistics();
        this.thereIsStatistics = true;
      } else {
        this.thereIsData = false;
        await this.getUsers();
        this.thereIsStatistics = false;
      }
    },
    async getAutoassignerInfo() {
      if (this.currentDepartment?.department_id === 1) {
        const params = {};
        params.skip = 0;
        params.limit = 100;
        await this.$store.dispatch(
          "usersManagement/autoassigner/getAutoassignerInfo",
          params
        );
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@include h1-font-size;

.spinner {
  @include spinner;
}

.users-management {
  min-height: $view-height;
  margin-bottom: $margin-most-used * 3;
  @include padding-view(1%);

  &__buttons {
    @include flex-wrap(space-between);

    &__title {
      display: flex;
      align-items: center;

      h4 {
        margin: 0px;
      }
    }

    &__content {
      @include flex-wrap(flex-end);
      margin: 0 0 1rem;
      &--option {
        @include primary-button;
        margin: 5px;
      }

      &--input {
        margin: 5px;
        width: 200px;
      }
    }
  }

  &__users-content {
    @include flex-wrap(space-around);
  }
}

@media (max-width: 484px) {
  .users-management__buttons__content--input {
    width: 100px;
  }
}
</style>
